import {useNavigate} from 'react-router';

import {statsRowT} from '@/lib/types/stats.types';

import {renderBrandTableStats} from '@/lib/config/brandTableConfig';

import {useViewQuery} from '@/hooks';

import {StatsRowComponent} from '@/components';
import Page from '@/components/Page';
import {DataTable} from '@/components/dataTable';
import DefaultTableAvatarImage from '@/components/defaultTableAvatarImage';

function AdminBrands() {
  const navigate = useNavigate();

  // Reactivity
  const {data: stats} = useViewQuery({
    view: 'brand_stats',
  });

  // Stats data for stats component
  const statsRow: statsRowT = renderBrandTableStats(stats?.total, stats?.active, stats?.inactive);

  return (
    <Page currentPage="Brands">
      <StatsRowComponent stats={statsRow} />
      <DataTable
        columns={[
          'brand_name',
          'brand_email',
          'brand_city',
          'brand_postal_code',
          'brand_phone',
          'brand_license_number',
          'brand_logo_url',
          'brand_id',
        ]}
        columnsDisplay={[
          {
            header: 'Name',
            field: 'brand_name',
            render: row => (
              <div className="flex min-w-[150px] gap-2">
                <DefaultTableAvatarImage src={row.brand_logo_url} alt="Brand Logo" />
                <div className="flex flex-col">
                  <span>{row.brand_name}</span>
                  <span className="text-muted text-truncate text-gray text-xs text-textmuted">
                    {row.brand_license_number}
                  </span>
                </div>
              </div>
            ),
          },
          {
            header: 'Email',
            field: 'brand_email',
          },
          {
            header: 'City',
            field: 'brand_city',
          },
          {
            header: 'Postal Code',
            field: 'brand_postal_code',
          },
        ]}
        table="Brand"
        searchColumn="brand_name"
        hideAdd
        actionsDisplay={[
          {
            icon: 'bi bi-arrows-angle-expand',
            color: 'info',
            handler: row => {
              navigate(`/brands/${row.brand_id}`);
            },
            permission: () => true,
          },
        ]}
      />
    </Page>
  );
}

export default AdminBrands;
